export default {
  getProductsData: () => Promise.resolve(),
  purchase: () => Promise.resolve(),
  restoreProducts: () => Promise.resolve(),
};
